import Container from './PublicArticlePage';
export default Container;

export const componentName = 'PublicArticlePage';
